(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["axd-fit-navigation"] && !Shopify.designMode) return;
  try {
    const axdCollectionForm=document.querySelector('[data-axdr-collection-filters]');
const axdFitRoute=axdCollectionForm?.querySelector('[data-axd-fit-route]');
if(axdFitRoute){
 const carry=(address,allFilters)=>{
  const target=new URL(address,location.origin);
  if(target.origin!==location.origin||!target.pathname.includes('/collections/'))return target;
  const current=new URL(location.href);
  const sizeInputs=[...axdCollectionForm.querySelectorAll('[data-axd-size-filter] input[type="checkbox"]')];
  const sizeNames=new Set(sizeInputs.map(i=>i.name));
  const sizes=sizeInputs.filter(i=>i.checked);
  if(allFilters){
   for(const [key,value] of current.searchParams){if(value&&(key==='sort_by'||key==='axd_color'||key==='axd_material'||key.startsWith('filter.v.price.')))target.searchParams.append(key,value);}
   for(const el of axdCollectionForm.querySelectorAll('[name="axd_color"],[name="axd_material"],[name="sort_by"],input[name^="filter.v.price."]')){target.searchParams.delete(el.name);if(el.value)target.searchParams.append(el.name,el.value);}
  }
  for(const name of sizeNames)target.searchParams.delete(name);
  const canonicalSize=value=>{const match=value.trim().toUpperCase().match(/\(([A-Z]+|\d+XL)\)$/);return match?match[1]:value.trim().toUpperCase();};
  const denimPath=new URL(axdFitRoute.dataset.axdDenimUrl,location.origin).pathname.replace(/\/$/,'');
  const isDenim=target.pathname.replace(/\/$/,'')===denimPath;
  const denimSizes=(axdFitRoute.dataset.axdDenimSizes||'').split('|').filter(Boolean);
  for(const input of sizes){const canonical=canonicalSize(input.value);const value=isDenim?(denimSizes.find(v=>canonicalSize(v)===canonical)||input.value):canonical;target.searchParams.append(input.name,value);}
  target.searchParams.delete('axd_fit');target.searchParams.delete('page');
  return target;
 };
 axdFitRoute.addEventListener('change',()=>location.assign(carry(axdFitRoute.value,true).href));
 document.addEventListener('click',event=>{
  const link=event.target.closest('.axdr-header__navigation a,.axdr-menu-links a,.axd-pants-explorer a,.axdr-category-menu a,.axd-breadcrumbs a');
  if(!link||!link.getAttribute('href'))return;
  const target=carry(link.href,false);
  if(target.origin===location.origin&&target.pathname.includes('/collections/'))link.href=target.href;
 });
 const clean=new URL(location.href);if(clean.searchParams.has('axd_fit')){clean.searchParams.delete('axd_fit');history.replaceState({},'',clean);}
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axd-pants-explorer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',(event)=>{
 const next=event.target.closest('[data-axd-pants-next]'),back=event.target.closest('[data-axd-pants-back]');
 if(!next&&!back)return;
 event.preventDefault();event.stopPropagation();
 const root=(next||back).closest('[data-axd-pants-explorer]');
 const types=root.querySelector('[data-axd-pants-stage="types"]'),fits=root.querySelector('[data-axd-pants-stage="fits"]'),trigger=root.querySelector('[data-axd-pants-next]');
 if(!fits.id)fits.id='axd-pants-fits-'+crypto.randomUUID();
 trigger.setAttribute('aria-controls',fits.id);
 types.hidden=!!next;fits.hidden=!next;trigger.setAttribute('aria-expanded',String(!!next));
 (next?fits:types).focus({preventScroll:true});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axd-search-panel"] && !Shopify.designMode) return;
  try {
    (() => {
  const ready = () => document.querySelectorAll('[data-axd-search-panel]').forEach((panel, index) => {
    if (panel.dataset.axdSearchReady) return;
    const form = panel.previousElementSibling;
    const input = form?.tagName === 'FORM' ? form.querySelector('input[name=q]') : null;
    if (!input) return;
    panel.dataset.axdSearchReady = 'escape-modal-v2';
    const initial = panel.querySelector('[data-axd-search-default]');
    const live = panel.querySelector('[data-axd-search-live]');
    let timer, controller, revision = 0;
    panel.id ||= 'axd-search-panel-' + index;
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');
    const cancel = () => {
      clearTimeout(timer);
      controller?.abort();
      controller = null;
      revision++;
      live.removeAttribute('aria-busy');
    };
    const show = () => {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };
    const hide = () => {
      cancel();
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };
    const allResults = value => {
      const link = document.createElement('a');
      link.className = 'axd-search-more';
      const target = new URL(form.action, location.origin);
      target.searchParams.set('q', value);
      target.searchParams.set('type', 'product');
      link.href = target.href;
      link.textContent = panel.dataset.allLabel;
      return link;
    };
    const links = () => Array.from(panel.querySelectorAll('a[href]')).filter(link => !link.closest('[hidden]'));
    const escape = event => {
      if (event.key !== 'Escape') return false;
      if (panel.hidden && panel.closest('dialog')?.open) {
        event.preventDefault();
        event.stopPropagation();
        panel.closest('dialog').close();
        return true;
      }
      event.preventDefault();
      event.stopPropagation();
      input.focus();
      hide();
      return true;
    };
    input.addEventListener('focus', show);
    input.addEventListener('input', () => {
      cancel();
      show();
      const value = input.value.trim();
      live.replaceChildren();
      if (!value) {
        initial.hidden = false;
        live.hidden = true;
        return;
      }
      initial.hidden = true;
      live.hidden = false;
      live.setAttribute('aria-busy', 'true');
      const currentRevision = revision;
      timer = setTimeout(async () => {
        const requestController = new AbortController();
        controller = requestController;
        const root = panel.dataset.root.replace(/\/?$/, '/');
        const params = new URLSearchParams({
          q: value,
          'resources[type]': 'product',
          'resources[limit]': '6',
          'resources[options][unavailable_products]': 'hide'
        });
        const isCurrent = () => revision === currentRevision && !requestController.signal.aborted && !panel.hidden && input.value.trim() === value;
        try {
          const response = await fetch(root + 'search/suggest.json?' + params, { signal: requestController.signal });
          if (!response.ok) throw new Error('search_unavailable');
          const data = await response.json();
          if (!isCurrent()) return;
          const items = data.resources?.results?.products || [];
          const heading = document.createElement('h3');
          heading.textContent = panel.dataset.resultLabel;
          live.append(heading);
          if (!items.length) {
            const empty = document.createElement('p');
            empty.className = 'axd-search-empty';
            empty.textContent = panel.dataset.emptyLabel;
            live.append(empty);
          }
          items.forEach(item => {
            const link = document.createElement('a');
            link.className = 'axd-search-item';
            link.href = item.url;
            if (item.image) {
              const img = document.createElement('img');
              img.src = item.image;
              img.alt = '';
              img.loading = 'lazy';
              img.width = 44;
              img.height = 58;
              img.addEventListener('error', () => img.remove(), { once: true });
              link.append(img);
            }
            const name = document.createElement('span');
            name.textContent = item.title;
            link.append(name);
            live.append(link);
          });
          live.append(allResults(value));
        } catch (error) {
          if (error.name === 'AbortError' || !isCurrent()) return;
          live.replaceChildren();
          const message = document.createElement('p');
          message.className = 'axd-search-empty';
          message.textContent = panel.dataset.errorLabel;
          live.append(message, allResults(value));
        } finally {
          if (revision === currentRevision) {
            live.removeAttribute('aria-busy');
            if (controller === requestController) controller = null;
          }
        }
      }, 250);
    });
    input.addEventListener('keydown', event => {
      if (escape(event)) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        show();
        const targets = links();
        const next = event.key === 'ArrowDown' ? targets[0] : targets.at(-1);
        if (next) {
          event.preventDefault();
          next.focus();
        }
      }
    });
    panel.addEventListener('keydown', event => {
      if (escape(event)) return;
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const targets = links();
      const position = targets.indexOf(document.activeElement);
      if (position < 0) return;
      event.preventDefault();
      const next = position + (event.key === 'ArrowDown' ? 1 : -1);
      if (next < 0 || next >= targets.length) input.focus();
      else targets[next].focus();
    });
    const focusout = () => setTimeout(() => {
      if (!form.contains(document.activeElement) && !panel.contains(document.activeElement)) hide();
    }, 0);
    form.addEventListener('focusout', focusout);
    panel.addEventListener('focusout', focusout);
    form.addEventListener('submit', hide);
    document.addEventListener('click', event => {
      if (event.target.closest('[data-axdr-open="search"]') && panel.closest('[data-axdr-dialog="search"]')?.open) {
        show();
        return;
      }
      if (!panel.contains(event.target) && !form.contains(event.target)) hide();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) hide();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axdr-collection-filters"] && !Shopify.designMode) return;
  try {
    const axdInitFilterPanels=()=>{
 const mq=window.matchMedia('(max-width:749px)');
 document.querySelectorAll('.axd-filter-panel').forEach(panel=>{
  if(panel.dataset.axdReady)return;
  panel.dataset.axdReady='true';panel.open=!mq.matches;
  const form=panel.closest('form'),badge=panel.querySelector('[data-axd-filter-count]');
  const update=(initial=false)=>{
   let count=0;
   if(initial){for(const [key,value] of new URLSearchParams(location.search)){if(value&&(key.startsWith('filter.')||['axd_color','axd_fit','axd_material','axd_min_price','axd_max_price'].includes(key)))count++;}}
   else{for(const el of form.querySelectorAll('[name]')){if(el.name==='sort_by'||el.disabled||!el.value)continue;if((el.type==='checkbox'||el.type==='radio')&&!el.checked)continue;count++;}}
   if(badge){badge.hidden=count===0;badge.textContent=count?'('+count+')':'';}
  };
  update(true);form.addEventListener('change',()=>update());form.addEventListener('input',()=>update());
  mq.addEventListener('change',()=>{panel.open=!mq.matches;});
 });
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',axdInitFilterPanels,{once:true});else axdInitFilterPanels();
document.addEventListener('shopify:section:load',axdInitFilterPanels);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axdr-header"] && !Shopify.designMode) return;
  try {
    const axdPlaceMenu=(details)=>{
 const menu=details.querySelector(':scope > .axdr-pants-menu');
 if(!menu||!details.open)return;
 const anchor=details.getBoundingClientRect();
 const width=menu.getBoundingClientRect().width;
 const left=Math.max(16,Math.min(anchor.left,window.innerWidth-width-16));
 details.style.setProperty('--axd-menu-left',(left-anchor.left)+'px');
};
const axdMenuAnchors=[...document.querySelectorAll('.axdr-header__navigation .axdr-pants-dropdown,.axdr-header__navigation .axdr-category-dropdown')];
axdMenuAnchors.forEach(d=>d.addEventListener('toggle',()=>{if(d.open)axdPlaceMenu(d);}));
window.addEventListener('resize',()=>axdMenuAnchors.filter(d=>d.open).forEach(axdPlaceMenu),{passive:true});
  } catch(e) { console.error(e); }
})();

})();
